import { DetailFieldList } from "@/shared/components";
import { DetailSection } from "../../../detail-section";
import { DetailTabela } from "../../../detail-tabela";
import styles from "./acomodacoes-section.module.scss";
import type { AcomodacoesSectionViewModel } from "./types-acomodacoes-section";

export function AcomodacoesSectionView({
  id,
  title,
  testId,
  fieldsTestId,
  status,
  errorMessage,
  loadingMessage,
  emptyContent,
  onReauthenticate,
  onRetry,
  ultimaAtualizacao,
  fields,
  tabela,
}: AcomodacoesSectionViewModel) {
  return (
    <DetailSection
      id={id}
      title={title}
      ultimaAtualizacao={ultimaAtualizacao}
      testId={testId}
      status={status}
      loadingMessage={loadingMessage}
      errorMessage={errorMessage}
      emptyContent={emptyContent}
      onReauthenticate={onReauthenticate}
      onRetry={onRetry}
    >
      <div className={styles.body}>
        <DetailFieldList testId={fieldsTestId} fields={fields} />

        {tabela ? <DetailTabela {...tabela} /> : null}
      </div>
    </DetailSection>
  );
}
